<template>
    <div class="page">

        <left-sidebar></left-sidebar>

        <div class="page-content-wrap">
            <nav class="">
                <div>
                    <!--  checked left menu for links -->
                    
                    <div v-if="checkBoxesState" style="margin-bottom: 1rem;">
                        <ul class="breadcrumbs remaining-count">
                             <li><input @change="checkAll()" type="checkbox" :checked="checkBoxesState" id="aaaaaaa" class="cbx" style="display: none;">
                                <label for="aaaaaaa" class="check">
                                  <svg width="14px" height="14px" viewBox="0 0 18 18">
                                    <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path>
                                    <polyline points="1 9 7 14 15 4"></polyline>
                                </svg>
                            </label>
                        </li>
                            <li><h1>{{checkBoxesState}} checked items</h1></li>
                        </ul>
                    </div>

                    <ul class="breadcrumbs" v-else>
                        <li><input @change="checkAll()" type="checkbox" id="aaaaaaa" class="cbx" style="display: none;">
                                <label for="aaaaaaa" class="check">
                                  <svg width="14px" height="14px" viewBox="0 0 18 18">
                                    <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path>
                                    <polyline points="1 9 7 14 15 4"></polyline>
                                </svg>
                            </label>
                        </li>
                        <li><h1 class=""> Модули</h1></li>
                    </ul>
                    <!-- END checked left menu for links -->

                    <!-- checked right menu for links -->
                    <ul class="buttons-do l-fe" v-if="!checkBoxesState">
                        <li> <i aria-hidden="true" class="fa fa-plus-square-o"></i> <router-link :to="{ name: 'module-slider-create' }"> Създай слайдер </router-link></li>

                        <li @click="changeFilter('status-1')">Статус: <span class="on"><i  class="fa fa-power-off status colorGreen" aria-hidden="true"></i></span></li>
                        <li @click="changeFilter('status-0')">Статус: <span class="off"><i  class="fa fa-power-off status " aria-hidden="true"></i></span></li>
                    </ul>
                    <ul class="buttons-do l-fe" v-else>
                        <li @click="massActItem('copy')"> <i aria-hidden="true" class="fa fa-files-o"></i> Копирай</li>
                        <li @click="massActItem('remove')"> <i class="fa fa-trash-o" aria-hidden="true"></i> Изтрий</li>
                        <li @click="massActItem('status-on')"><i class="fa fa-power-off status colorGreen" aria-hidden="true"></i> Включи</li>
                        <li @click="massActItem('status-off')"><i class="fa fa-power-off status " aria-hidden="true"></i> Изключи</li>
                    </ul>
                    <!-- END checked right menu for links -->



                    <mode></mode>

                </div>

                <div>
                    <ul class="nav-page pb10" >

                        <li class="active"><router-link :to="{ name: 'module-slider' }"> Слайдер </router-link></li>

                        <input class="search-product" placeholder="Търсяне в продукти" style="float:right" type="text" v-model="search" @keyup.enter="searchItems()">
                    </ul>

                </div>
                
            </nav>
            <div class="content-place">
                
<div v-if="loading" class="lds-dual-ring spinner"></div>

                <div>
                    <div  class="table-content-place">

                        <draggable
                        class="dragArea "
                        :list="items"
                        group="people"
                        >

                        <div  v-for="(item, index) in items" :key="item.id"  class="ml0 row table header-table card-img-top imgs-sortable">

                            <div class="col-lg-1" style="text-align:right">

                                <input @change="changeStateCheckbox(item.id)" v-model="item.check" type="checkbox" :id="item.id" class="cbx" style="display: none;">
                                <label :for="item.id" class="check">
                                  <svg width="14px" height="14px" viewBox="0 0 18 18">
                                    <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"></path>
                                    <polyline points="1 9 7 14 15 4"></polyline>
                                </svg>
                            </label>

                            <img :src="item.images" alt="title">
                        </div>
                        <div class="col-lg-4 name" >
                            <span :title="item.title">{{ item.title }}</span>
                            <span class="type-folder"> <i @click="changeStatus(item.id)" class="fa fa-power-off status" :class="{colorGreen: item.status == 1}" aria-hidden="true"></i> </span>
                        </div>

                        <div class="col-lg-2">
                            <span>{{ item.code }}</span>
                        </div>
                        <div class="col-lg-3">
                            <span>{{ item.price }}.00 лв</span>
                        </div>
                        <div class="col-lg-1">
                           <span @click="activeOptions == item.id ? activeOptions = 0 : activeOptions = item.id"><i class="fa fa-ellipsis-h" aria-hidden="true"></i>

                           </span>
                           <div  class="wrap-option-folder-menu" v-if="activeOptions == item.id">
                            <ul class="option-folder-menu  table-option-wrap">
                                <li><router-link :to="{ name: 'shop-product-edit', params: { id: item.id }  }"> Редактирай</router-link></li>
                                <li @click="oneActItem(item.id,'copy')">Копирай</li>
                                <li @click="oneActItem(item.id,'remove')">Изтрий</li>
                            </ul>
                        </div>


                    </div>


                </div>
            </draggable>
        </div>

    </div>

    <div >
        <div class="empty-folder" v-if="items.length == 0 && loading == false">
            <img src="http://perpao.com/empty-folder.png" alt="">
            <div class="content-empty-folder">
                <h3>Нищо не намерено</h3>

            </div>

        </div>
    </div>

</div>

</div>



</div>
</template>

<script>

    import axios from 'axios'

    
    import mode from '../../../layouts/mode'

    import LeftSidebar from '../../../layouts/LeftSidebar'


    import database from '../../../../mixins/database'
    import sortable from '../../../../mixins/sortable'

    export default {
        name: 'system-moduls',
        
        data() {
            return {
                dataBase: {
                    selectFrom: 'module-slider',
                },
               // checkBoxesState: true,
               activeOptions: false,
               sortable: true,
               loading: false,
             
               /**  From mixins available is currect domain, items  */

           }
       },
    
       components: {
        LeftSidebar,
        mode,

    },

        // mixins - database - get ( sortable: true / false ). 
        mixins: [database, sortable],



    }

</script>

<style scoped src="../../../../assets/css/page-index.css"></style>
<style scoped src="../../../../assets/css/table.css"></style>


// WEBPACK FOOTER //
// src/components/system/web_modules/slider/index.vue